// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import getRealTimeWarehouseInventory from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import translate from "@insite/client-framework/Translate";
// Valtech Custom Code
// import {
//     AvailabilityDto,
//     AvailabilityMessageType,
//     ProductSettingsModel,
//     WarehouseDto,
// } from "@insite/client-framework/Types/ApiModels";
// Valtech Custom Code
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// import Icon, { IconWrapper } from "@insite/mobius/Icon"; // Valtech Custom Code
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Check from "@insite/mobius/Icons/Check";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import safeColor from "@insite/mobius/utilities/safeColor";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

/* Valtech Custom Code - Start */
// import Icon, { IconPresentationProps } from "@insite/mobius/Icon"; // Store Custom Code
import Loader from "@store/Library/Components/Toolkit/Loader";
import { linkAltStyles } from "@store/Themes/common/mixins/link";
import { StatusColor, statusStyles } from "@store/Themes/common/mixins/status";
import { loadingDotsStyles } from "@store/Themes/common/mixins/typography";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import AlertCircleFill from "@toolkit/Library/Components/Icons/AlertCircle/AlertCircleFill";
import AlertTriangleFill from "@toolkit/Library/Components/Icons/AlertTriangle/AlertTriangleFill";
import CheckmarkCircle2Fill from "@toolkit/Library/Components/Icons/CheckmarkCircle2/CheckmarkCircle2Fill";
import InfoFill from "@toolkit/Library/Components/Icons/Info/InfoFill";
/* Valtech Custom Code - End */

/* Store Custom Code - Start */
import CloseCircled from "@store/Library/Components/Icons/CloseCircled";
import {
    AvailabilityDto,
    AvailabilityMessageType,
    ProductSettingsModel,
    WarehouseDto,
} from "@insite/client-framework/Types/ApiModels";
import { IconPresentationProps } from "@store/MobiusOverrides/Icon/Icon";
import useGetInventory from "@store/Framework/Store/Data/Products/ProductsHooks/useGetInventory";
import ProductStatusMessage from "@store/Library/Components/ProductAvailability/ProductStatusMessage";
import colors from "@store/Themes/common/styleguide/config/colors";

/* Store Custom Code - End */

interface OwnProps {
    productId: string;
    availability?: AvailabilityDto;
    unitOfMeasure: string;
    trackInventory: boolean;
    isProductDetailsPage?: boolean;
    failedToLoadInventory?: boolean;
    extendedStyles?: ProductAvailabilityStyles;
    // Valtech Custom Code
    overridedStyles?: ProductAvailabilityStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
    showInventory: state.context.showInventory,
});

const mapDispatchToProps = {
    getRealTimeWarehouseInventory,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ProductAvailabilityStyles {
    container?: GridContainerProps;
    messageGridItem?: GridItemProps;
    availabilityByWarehouseLinkGridItem?: GridItemProps;
    inventoryMessage?: InjectableCss;
    messageText?: TypographyPresentationProps;
    realTimeText?: TypographyPresentationProps;
    errorWrapper?: InjectableCss;
    errorText?: TypographyPresentationProps;
    availabilityByWarehouseLink?: LinkPresentationProps;
    availabilityByWarehouseModal?: ModalPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    availabilityByWarehouseTable?: DataTableProps;
    availabilityByWarehouseTableHead?: DataTableHeadProps;
    availabilityByWarehouseTableHeader?: DataTableHeaderProps;
    availabilityByWarehouseTableBody?: DataTableBodyProps;
    availabilityByWarehouseTableRow?: DataTableRowProps;
    availabilityByWarehouseTableCell?: DataTableCellBaseProps;
    // Valtech Custom Code
    availabilityByWarehouseIcon?: IconPresentationProps;
    wrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
}

export const productAvailabilityStyles: ProductAvailabilityStyles = {
    /* Store Custom Code - Start */
    container: {
        gap: 0,
        css: css`
            flex-grow: 0;
        `,
    },
    messageGridItem: { width: 12 },
    availabilityByWarehouseLinkGridItem: { width: 12 },
    availabilityByWarehouseModal: {
        size: 400,
        cssOverrides: {
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                padding: ${pxToRem(10)} ${pxToRem(10)} ${pxToRem(10)} ${pxToRem(20)};
            `,
            headlineTypography: css`
                font-size: ${pxToRem(20)};
                margin-bottom: 0;
            `,
        },
    },
    centeringWrapper: {
        css: css`
            height: ${pxToRem(100)};
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
    messageText: {
        css: css`
            width: 100%;
            white-space: normal;
            word-break: normal;
            ${wrapInContainerStyles}
            ${({ theme }) => `
                font-size: ${theme.design.typography.size.smaller};
                font-weight: ${theme.design.typography.weight.bold};
                line-height: ${theme.design.typography.lineHeight.small};
            `}
        `,
    },
    realTimeText: {
        weight: "bold",
        css: css`
            display: inline-block;
            text-align: left;
            min-width: ${pxToRem(25)};

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    errorText: {
        weight: "bold",
    },
    /* Store Custom Code - End */
};

/* Valtech Custom Code - Start */
const InventoryMessage = styled.div<{ _color: StatusColor } & InjectableCss>`
    ${x => statusStyles(x._color)}
    ${props => props.css}
`;
/* Valtech Custom Code - End */

// Valtech Custom Code - next line - return type: StatusColor

const getAvailabilityColor = (productSettings: ProductSettingsModel, availability?: AvailabilityDto): StatusColor => {
    if (!productSettings.showInventoryAvailability) {
        return "neutral"; // Valtech Custom Code
    }

    const availabilityType = availability?.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        return "danger";
    }

    if (availabilityType === AvailabilityMessageType.LowStock) {
        return "warning";
    }

    return "success";
};
// bunzl deleted code getavailibilityIcon

/* Store Custom Code - Start */
export const getStatusColor = (
    availabilityMessageColor: string | undefined,
    defaultColor = colors!.info!.main!,
): string => {
    const hasValidMessageColor = availabilityMessageColor?.includes("#");

    return hasValidMessageColor && availabilityMessageColor ? availabilityMessageColor : defaultColor;
};
/* Store Custom Code - End */

const ProductAvailability = ({
    productId,
    availability,
    unitOfMeasure,
    productSettings,
    getRealTimeWarehouseInventory,
    failedToLoadInventory,
    extendedStyles,
    // Valtech Custom Code
    overridedStyles,
}: Props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [warehouses, setWarehouses] = useState<WarehouseDto[] | undefined>(undefined);
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    /* Store Custom Code - Start */
    const inventory = useGetInventory();
    const {
        isInStock,
        isOutOfStock,
        isBackorder,
        isWhileSuppliesLast,
        availabilityMessage,
        availabilityIcon: availabilityMessageBackgroundColor,
        availabilityMessageColor,
    } = inventory;
    const customColorAndIcon = {
        availabilityMessageColor: availability?.messageColor ?? availabilityMessageColor,
        availabilityMessageIcon: availability?.messageIcon ?? availabilityMessageBackgroundColor,
    };
    /* Store Custom Code - End */
    const defaultColor = getAvailabilityColor(productSettings, availability);
    const customColor = availability?.messageColor ?? availabilityMessageColor;
    // Bunzl Custom Code
    const color = getStatusColor(customColor, defaultColor);
    const styles = useExpandProps(productAvailabilityStyles, extendedStyles, overridedStyles); // Valtech Custom Code

    /* Valtech Custom Code - Start */
    const unavailableMessage = (
        <InventoryMessage _color="neutral" {...styles.inventoryMessage}>
            <Typography {...styles.messageText} data-test-selector="availabilityMessage">
                {siteMessage("RealTimeInventory_InventoryLoadFailed")}
            </Typography>
        </InventoryMessage>
    );
    /* Valtech Custom Code - End */

    if (failedToLoadInventory) {
        return <StyledWrapper {...styles.wrapper}>{unavailableMessage}</StyledWrapper>; // Valtech Custom Code
    }
    /* Bunzl Custom Code - Start */

    return (
        <ProductStatusMessage
            extendedStyles={styles}
            message={availabilityMessage ?? availability?.message ?? ""}
            messageIcon={customColorAndIcon.availabilityMessageIcon ?? ""}
            messageColor={color}
        />
    );
    /* Bunzl Custom Code - End */

    // Valtech Removed Code - Warehouses table modal
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductAvailability);
